import './table'
import './bbb-review'
import './lazy-load'

document.addEventListener('DOMContentLoaded', () => {
  const bonusFinder = document.getElementById('bonus-finder-form')
  if (bonusFinder) {
    bonusFinder.addEventListener('mousemove', () => {
      const scr = document.createElement('script')
      scr.src = `${BBB.assetsUrl}js/bonus-finder.js`
      document.body.appendChild(scr)
    }, { once: true })
  }
})

const menuButton = document.querySelector('.menu-toggle')
if (menuButton) {
  menuButton.addEventListener('click', (e) => {
    e.preventDefault()
    menuButton.querySelectorAll('svg').forEach(svg => {
      svg.classList.toggle('hidden')
    })
    const wrapper = menuButton.parentElement.querySelector('#menu-header')
    if (wrapper) {
      wrapper.classList.toggle('hidden')
      wrapper.classList.toggle('px-4')
      wrapper.classList.toggle('pb-4')
    }
  })
}
